import { api } from "@/api/axios.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import {
  ApiEmployeeWorkflowRunPayload,
  ApiEmployeeWorkflowRunResult,
  ApiWorkflowFilter,
  ApiWorkflowShort,
} from "@/types/workflows/workflow.types.ts";

export const employeeWorkflowApi = {
  search: async function (employeeId: number, filter: ApiWorkflowFilter, signal: AbortSignal) {
    return api.post<ApiPagedData<ApiWorkflowShort>>(
      `/api/v1/employees/${employeeId}/workflows/search`,
      filter,
      signal
    );
  },
  run: async function (
    employeeId: number,
    workflowId: number,
    payload: ApiEmployeeWorkflowRunPayload = {},
    signal?: AbortSignal
  ) {
    return api.post<ApiEmployeeWorkflowRunResult>(
      `/api/v1/employees/${employeeId}/workflows/${workflowId}/run`,
      payload,
      signal
    );
  },
};
